
export default function promisify<T>( method: () => T | Promise<T> ): Promise<T> {
	return new Promise( ( resolve, reject ) => {
		const wait = method();

		if ( wait instanceof Promise ) {
			wait.then( ( x ) => {
				resolve( x );
			} ).catch( ( err ) => {
				reject( err );
			} );
		} else {
			resolve( wait );
		}
	} );
}
